/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import cx from 'classnames';

import {
  Input,
  Radio,
  Navigation,
  KeyboardNav,
} from '../../../../../components/shared';

import styles from '../../../Forms.scss';
import stylesForm from '../../../../../components/shared/Form/Form.scss';

export const cateringList = [
  {
    id: 'yes',
    label: 'Yes',
  },
  {
    id: 'no',
    label: 'No',
  },
];

const Catering = ({ setForm, formData, navigation, step, index }) => {
  const { catering } = formData;
  const { next, previous } = navigation;
  const [isValid, setIsValid] = useState(false);
  KeyboardNav(step, isValid, navigation);

  useEffect(() => {
    if (catering !== '') {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }, [formData, isValid]);

  return (
    <div>
      <h4>
        <span>{index + 1}</span> Is Catering Required? *
      </h4>

      <div className={cx(styles.form__multiple, styles.form__multiple__col1)}>
        {cateringList.map(type => {
          const { id, label } = type;

          return (
            <Radio
              id={id}
              key={id}
              label={label}
              name="catering"
              value={id}
              checked={catering === id}
              onChange={setForm}
              type="radio"
            />
          );
        })}
      </div>
      {catering === 'yes' && (
        <div className={styles.catering__details}>
          <p>
            Catering requests must be made at least two weeks in advance of the
            event. The requesting company/team from HPE or HPI is responsible
            for securing catering services. Preferred caterers are:
          </p>
          <ul>
            <li>
              Handheld Catering through An Bui at{' '}
              <a href="mailto:an@handheldcatering.com">
                an@handheldcatering.com
              </a>
            </li>
            <li>
              Cuisine Style through Pamela Keith (Owner/Operator) at
              650.888.8720
            </li>
            <li>
              Macarena through Matxalen Aketxe at{' '}
              <a href="mailto:maketxe@macarenarestaurant.com">
                maketxe@macarenarestaurant.com
              </a>
            </li>
          </ul>
          <p>
            Once catering needs are determined, the requester is responsible for
            finalizing the catering costs, menus, and plans.
          </p>
        </div>
      )}

      <Navigation navigation={navigation} isValid={isValid} />
    </div>
  );
};

export default Catering;
